var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_404_627)",
    fillRule: "evenodd",
    d: "M342.914 99.347c.811-.463 1.968-.463 2.894 0l29.28 16.318c1.852 1.042 3.009 3.01 3.009 5.208v141.078c0 2.083-1.157 4.051-3.009 5.092l-49.07 28.355a5.97 5.97 0 01-5.903 0l-49.07-28.355c-1.852-1.041-3.009-3.009-3.009-5.092v-56.593c0-2.083 1.157-4.051 3.009-5.092l49.07-28.355a5.97 5.97 0 015.903 0l12.267 7.06c.695.347 1.389.347 2.083 0 .695-.463 1.042-1.157 1.042-1.852v-75.226c0-1.041.579-1.967 1.504-2.546zm-19.096 154.966l16.781-9.722c.463-.231.695-.694.695-1.273v-19.443c0-.463-.232-1.041-.695-1.273l-16.781-9.721a1.712 1.712 0 00-1.504 0l-16.782 9.721c-.462.232-.694.695-.694 1.273v19.443c0 .463.232 1.042.694 1.273l16.782 9.722a1.719 1.719 0 001.504 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_404_627)",
    d: "M109.946 203.854c0-2.084-1.158-4.051-3.009-5.093l-49.07-28.238c-.81-.463-1.737-.695-2.663-.81h-.463c-.925 0-1.851.347-2.661.81L3.009 198.761C1.157 199.803 0 201.77 0 203.854l.116 75.92c0 1.042.578 2.083 1.504 2.546.926.579 2.083.579 2.894 0l29.164-16.665c1.852-1.042 3.01-3.009 3.01-5.093v-35.529c0-2.084 1.156-4.051 3.008-5.093l12.384-7.175c.925-.579 1.967-.81 3.009-.81 1.041 0 2.083.231 2.893.81l12.383 7.175c1.852 1.042 3.01 3.009 3.01 5.093v35.529c0 2.084 1.157 4.051 3.008 5.093l29.165 16.665a2.823 2.823 0 003.009 0c.926-.463 1.505-1.504 1.505-2.546l-.116-75.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_404_627)",
    d: "M253.222 412.519c-1.736 0-3.356-.463-4.861-1.273l-15.392-9.143c-2.315-1.273-1.158-1.736-.463-1.967 3.125-1.042 3.703-1.273 6.944-3.125.347-.232.81-.116 1.157.116l11.805 7.059c.463.232 1.041.232 1.389 0l46.177-26.734c.463-.231.694-.694.694-1.273v-53.353c0-.578-.231-1.041-.694-1.273l-46.177-26.618c-.463-.232-1.042-.232-1.389 0l-46.177 26.618c-.463.232-.695.81-.695 1.273v53.353c0 .463.232 1.042.695 1.273l12.614 7.291c6.829 3.472 11.111-.578 11.111-4.629v-52.658c0-.695.578-1.389 1.389-1.389h5.902c.694 0 1.389.579 1.389 1.389v52.658c0 9.143-4.977 14.467-13.657 14.467-2.662 0-4.745 0-10.647-2.894l-12.152-6.944c-3.009-1.736-4.861-4.976-4.861-8.448v-53.353c0-3.472 1.852-6.712 4.861-8.448l46.177-26.734c2.894-1.621 6.828-1.621 9.722 0l46.177 26.734c3.009 1.736 4.861 4.976 4.861 8.448v53.353c0 3.472-1.852 6.712-4.861 8.448l-46.177 26.734c-1.505.695-3.241 1.042-4.861 1.042z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_404_627)",
    d: "M267.457 375.832c-20.253 0-24.419-9.259-24.419-17.129 0-.694.578-1.388 1.388-1.388h6.018c.695 0 1.273.463 1.273 1.157.926 6.134 3.588 9.143 15.856 9.143 9.721 0 13.888-2.199 13.888-7.407 0-3.009-1.158-5.208-16.319-6.713-12.614-1.273-20.484-4.05-20.484-14.119 0-9.374 7.87-14.929 21.063-14.929 14.814 0 22.105 5.092 23.031 16.202 0 .347-.116.695-.347 1.042-.232.231-.579.463-.926.463h-6.018c-.579 0-1.158-.463-1.273-1.042-1.389-6.365-4.977-8.448-14.467-8.448-10.647 0-11.92 3.703-11.92 6.481 0 3.356 1.504 4.398 15.855 6.249 14.235 1.852 20.948 4.514 20.948 14.467-.116 10.184-8.449 15.971-23.147 15.971z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_404_627)",
    d: "M479.942 240.425l29.165-17.013c1.851-1.041 2.893-3.009 2.893-5.092v-13.772c0-2.083-1.157-4.051-2.893-5.092l-48.724-28.239a5.962 5.962 0 00-5.902 0l-49.071 28.354c-1.851 1.042-3.009 3.009-3.009 5.093v56.593c0 2.083 1.158 4.05 3.009 5.092l48.724 27.776c1.852 1.041 4.05 1.041 5.786 0l29.512-16.434c.926-.463 1.505-1.505 1.505-2.546 0-1.042-.579-2.083-1.505-2.546l-49.302-28.355c-.926-.579-1.504-1.504-1.504-2.546v-17.707c0-1.042.578-2.083 1.504-2.546l15.393-8.796a2.827 2.827 0 013.009 0l15.392 8.796c.926.579 1.505 1.504 1.505 2.546v13.888c0 1.041.578 2.083 1.504 2.546a2.823 2.823 0 003.009 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_404_627)",
    d: "M457.837 220.75a1.052 1.052 0 00-1.157 0l-9.375 5.44c-.347.231-.578.579-.578 1.041v10.879c0 .463.231.81.578 1.042l9.375 5.439c.347.232.81.232 1.157 0l9.374-5.439c.348-.232.579-.579.579-1.042v-10.879c0-.462-.231-.81-.579-1.041l-9.374-5.44z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_404_627)",
    d: "M190.347 170.811a6.11 6.11 0 011.653.637l24.189 13.962 24.651 14.161c.509.287.975.644 1.382 1.053l.006-.011a6.052 6.052 0 011.193 1.707 5.44 5.44 0 01.544 2.344v56.361l-.001.034a5.652 5.652 0 01-.156 1.287l.04.068a5.996 5.996 0 01-.057.176l1.215 2.023v.694l-54.163 31.364-.846-1.586c-1.323.24-2.697-.028-3.899-.729l-48.954-28.123a6.08 6.08 0 01-1.621-1.389l.032-.054a6.741 6.741 0 01-.777-1.077c-.48-.814-.76-1.723-.76-2.688v-56.361c0-1.823.975-3.557 2.459-4.66.212-.158.435-.302.666-.433l48.839-28.123c.933-.593 1.989-.814 3.034-.799.468-.006.927.032 1.364.105l-.033.057z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_404_627)",
    d: "M183.784 161.495l.694-.347.232.347h-.926z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_404_627)",
    d: "M245.121 264.613l.347.579-.347.231v-.81z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_404_627",
    x1: 121.081,
    x2: 110.451,
    y1: 181.303,
    y2: 324.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.f7b57bbb02e0266ba315139e06e0f9dc.svg";
export { ForwardRef as ReactComponent };